import { createContext, useContext } from 'react';

/**
 * Etiqueta que una pantalla de detalle pone en la ruta de navegacion.
 *
 * La ruta se deriva de la URL, que para un documento termina en su UUID:
 * "Inicio > Requerimientos > 0c3f8a12-..." no le dice nada a nadie. La ficha
 * publica aqui el numero del documento -"REQ-2026-00042"- en cuanto lo
 * conoce, y lo retira al salir.
 */
export const CrumbContext = createContext<{
  label: string | null;
  setLabel: (label: string | null) => void;
}>({ label: null, setLabel: () => undefined });

export function useCrumbOverride(): (label: string | null) => void {
  return useContext(CrumbContext).setLabel;
}

export function useCrumbLabel(): string | null {
  return useContext(CrumbContext).label;
}
